<template>
    <div class="Combination">
        <span class="Combination-quantity">{{ Math.ceil(coats * quantity) }}</span>
        <hempel-icon :name="icon" />
        <span class="Combination-size">{{ size }}</span>
    </div>
</template>
<script>
import HempelIcon from '@/components/shared/icon/Icon'

export default {
    props: {
        quantity: {
            type: Number,
            default: 1
        },
        coats: {
            type: Number,
            default: 1
        },
        size: {
            type: String,
            default: '1L'
        },
        icon: {
            type: String,
            default: null
        }
    },
    components: {
        HempelIcon
    }
}
</script>
